export const FONT_WEIGHTS = ["regular", "semibold", "bold"] as const;

export type FontWeight = (typeof FONT_WEIGHTS)[number];

export const FONT_WEIGHT_OPTIONS = [
  { title: "Regular", value: "regular" },
  { title: "Semibold", value: "semibold" },
  { title: "Bold", value: "bold" },
] as const satisfies ReadonlyArray<{ title: string; value: FontWeight }>;
